import { render } from "./DictOption.vue?vue&type=template&id=a9a18d6a"
import script from "./DictOption.vue?vue&type=script&lang=js"
export * from "./DictOption.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT_SPACE\\EnterpriseCloud\\front_iview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__